/**
 * External control functions for modifying website content
 * These functions are exposed to the window object to allow external systems to update content
 */

// Store references to component update functions
const updateFunctions = {
    aiResponse: null,
    projectContent: {},
    messageHistory: []
};

// Register component update functions
export const registerAiResponseUpdater = (updateFn) => {
    updateFunctions.aiResponse = updateFn;
};

export const registerProjectUpdater = (projectId, updateFn) => {
    updateFunctions.projectContent[projectId] = updateFn;
};

export const registerMessageHistoryUpdater = (updateFn) => {
    updateFunctions.messageHistory.push(updateFn);
};

// Helper function to scroll to AI Tile
const scrollToAiTile = () => {
    // Scroll to top first
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    
    // Get the AI tile element
    const aiTile = document.querySelector('.ai-tile');
    if (aiTile) {
        // Add slight delay to ensure scroll completes properly
        setTimeout(() => {
            aiTile.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 100);
    }
};

// External control functions
const externalControls = {
    // Update AI response content
    updateAiResponse: (newContent) => {
        if (updateFunctions.aiResponse) {
            updateFunctions.aiResponse(newContent);
            
            // Scroll to the AI Tile after updating content
            scrollToAiTile();
            
            return true;
        }
        return false;
    },

    // Update a specific project's content
    updateProjectContent: (projectId, slideIndex, field, newContent) => {
        if (updateFunctions.projectContent[projectId]) {
            updateFunctions.projectContent[projectId](slideIndex, field, newContent);
            return true;
        }
        return false;
    },

    // Add a new message to the chat history
    addMessage: (message, isUser = false) => {
        updateFunctions.messageHistory.forEach(updater => updater({
            content: message,
            isUser,
            timestamp: new Date().toISOString()
        }));
        return true;
    },

    // Check if the portfolio is ready for external control
    isReady: () => {
        return !!updateFunctions.aiResponse;
    },
    
    // Expose scroll function for external usage
    scrollToAiTile: scrollToAiTile
};

// Expose the control functions to the window object
window.portfolioControls = externalControls;

export default externalControls; 